import React from 'react'

import { Box, Grid } from '@material-ui/core'
import { isEmpty } from 'lodash'

import {
  EvidenceCard,
  RadialGraphicsCard,
} from 'views/Suppliers/Home/components/InformationCard/components'
import { CardsListStructure, Skeletons, StatsChartCard } from './components'

import useThirdPartyManagementStepper from 'hooks/useThirdPartyManagementStepper'
import useFetch from 'hooks/useFetch'

import * as service from 'service'
import constants from 'constants/index'
import theme from 'theme'

const OverviewStep = () => {
  const { companySupplierId, isPreAvaliation } =
    useThirdPartyManagementStepper()

  const { response, isLoading } = useFetch(
    service.dponet.suppliers.supplierStats,
    { companySupplierId },
    [companySupplierId],
  )

  const { STEPS } = constants.tours.thirdPartyManagements

  const stats = response?.data
  const questionnaires = stats?.questionnaires || []
  const evidenceQuestionnaires = questionnaires.filter(
    (q) => q.totalRequiredEvidences > 0,
  )

  return (
    <>
      {isLoading ? (
        <Skeletons />
      ) : (
        <Box display="flex" flexDirection="column" gridGap={theme.spacing(3)}>
          <Grid container spacing={3}>
            <Grid
              id={
                isPreAvaliation
                  ? STEPS.PRE_AVALIATION.SHOW.OVERVIEW[1]
                  : STEPS.SHOW.OVERVIEW[1]
              }
              item
              xs={12}
              sm={6}
            >
              <StatsChartCard
                title="Progresso"
                value={stats?.generalProgress}
              />
            </Grid>
            <Grid
              id={
                isPreAvaliation
                  ? STEPS.PRE_AVALIATION.SHOW.OVERVIEW[2]
                  : STEPS.SHOW.OVERVIEW[2]
              }
              item
              xs={12}
              sm={6}
            >
              <StatsChartCard title="Conformidade" value={stats?.compliance} />
            </Grid>
          </Grid>

          <Grid container spacing={3}>
            <Grid
              id={
                isPreAvaliation
                  ? STEPS.PRE_AVALIATION.SHOW.OVERVIEW[3]
                  : STEPS.SHOW.OVERVIEW[3]
              }
              item
              xs={12}
              sm={6}
            >
              <CardsListStructure
                title="Resolução dos Questionários"
                emptyMessage="Nenhum questionário encontrado."
                isEmpty={isEmpty(questionnaires)}
              >
                {questionnaires?.map((questionnaire) => (
                  <RadialGraphicsCard
                    key={questionnaire.id}
                    title={questionnaire.kind}
                    subtitle={`Sua organização respondeu ${questionnaire.totalAnswers}/${questionnaire.totalQuestions} questões.`}
                    value={questionnaire.totalAnswers ?? 0}
                    percentage={questionnaire.answersPercentage}
                    onlyNumber
                  />
                ))}
              </CardsListStructure>
            </Grid>

            <Grid
              id={
                isPreAvaliation
                  ? STEPS.PRE_AVALIATION.SHOW.OVERVIEW[4]
                  : STEPS.SHOW.OVERVIEW[4]
              }
              item
              xs={12}
              sm={6}
            >
              <CardsListStructure
                title="Evidências"
                emptyMessage="Nenhuma evidência encontrada."
                isEmpty={isEmpty(evidenceQuestionnaires)}
              >
                {evidenceQuestionnaires.map((questionnaire) => (
                  <EvidenceCard
                    key={questionnaire.id}
                    title={questionnaire.kind}
                    value={`${questionnaire.totalEvidences}/${questionnaire.totalRequiredEvidences}`}
                    progressValue={questionnaire.evidencesPercentage}
                    minHeight={83}
                  />
                ))}
              </CardsListStructure>
            </Grid>
          </Grid>
        </Box>
      )}
    </>
  )
}

export default OverviewStep
